import { useQuery, type QueryKey } from '@tanstack/react-query';
import service from '@Service';
import type { AgentProfile } from '@Types/agent';

export const agentProfileKeys = {
  detail: (id: string) => ['agent-profile', id] as const,
};

export function useAgentProfile({
  soulId,
  enabled = true,
}: {
  soulId?: string;
  enabled?: boolean;
}) {
  return useQuery<AgentProfile>({
    queryKey: agentProfileKeys.detail(soulId!) as unknown as QueryKey,
    queryFn: () => service.getAgentProfile(soulId!),
    enabled: enabled && !!soulId,
  });
}

export function useAgentProfiles({
  enabled = true,
}: {
  soulId?: string;
  enabled?: boolean;
}) {
  const queryKey: QueryKey = ['agentProfiles'];
  return useQuery<AgentProfile[]>({
    queryKey,
    queryFn: () => service.getAgentProfiles(),
    enabled,
  });
}
